module.exports = __webpack_public_path__ + "static/img/drop-down-checkmark.9d66c83.svg";